<template>
  <div id="Tab2">
    <ValidationObserver ref="formTab2" v-slot="{ dirty }">
      <SaveObserver :dirty="dirty">
        <div class="tab-content">
          <SectionTitle
            icon="fas fa-file-alt"
            content="II. Información de Evaluaciones Realizadas"
            container-class="tag-badge-main-info mt-5 mb-4"
          />

          <Error
            v-if="controversyII && controversyII.existControversy"
            is-alert-mode
            :message="
              '<b>Parte en Controversia: </b>' +
                controversyII.informationMessage
            "
          />

          <SectionTitle
            :has-line="true"
            content="Comentario de Salud"
            container-class="mb-4"
          />
          <form novalidate>
            <div class="form-group pb-2 ml-0">
              <ValidationProvider
                v-slot="{ errors, invalid }"
                class="w-100"
                name="Comentario"
                :rules="`${ValidationTriggered.validation ? 'required' : ''}`"
                immediate
              >
                <custom-text-area
                  v-model="model.generalImpedimentDescription"
                  class="w-100"
                  :disabled="
                  ((!isDraft || !canEditTab2 || !hasSelectionInAmendant || admendmentIsEmpty)
                    && canUseTabEditRestriction
                    && !admendmentIsEmpty) || !isDraft
                  "
                  placeholder="Ingresar comentario de salud..."
                  :rows="5"
                  :maxlength="3000"
                  :error="`${invalid || errors[0] ? 'error' : ''}`"
                  :custom-error-msg="resources['R03200115']"
                />
              </ValidationProvider>
            </div>
            <!-- Information on Evaluations -->
            <SectionTitle
              :has-line="true"
              content="Información de Evaluaciones Realizadas"
              container-class="mb-4"
            />
            <div class="d-flex form-group pb-2 mt-neg-35 special-margin-bottom">
              <div class="col-3">
                <div>
                  <ValidationProvider
                    v-slot="{ errors, invalid }"
                    class="w-100"
                    name="Fecha de Evaluación existente"
                    immediate
                    :rules="
                      `${ValidationTriggered.validation ? 'required' : ''}`
                    "
                  >
                    <CustomDatePicker
                      v-model="model.evaluationAnalysisDate"
                      label="Análisis Evaluación Existente"
                      format="dd/MMM./yyyy"
                      :error="`${invalid || errors[0] ? 'error' : ''}`"
                      :custom-error-msg="resources['R03200116']"
                      :disabled="((canEditDates || !canEditTab2 || !hasSelectionInAmendant || admendmentIsEmpty) && canUseTabEditRestriction && !admendmentIsEmpty) || !isDraft"
                      @onSelectedDate="onAnalysisEvaluationChanged"
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-3">
                <div>
                  <ValidationProvider
                    v-slot="{ errors, invalid }"
                    class="w-100"
                    name="Fecha de Revisión Trianual"
                    :rules="
                      `${ValidationTriggered.validation ? 'required' : ''}`
                    "
                    immediate
                  >
                    <CustomDatePicker
                      v-model="model.evaluationTriannualDate"
                      label="Revisión Trianual"
                      format="dd/MMM./yyyy"
                      :error="`${invalid || errors[0] ? 'error' : ''}`"
                      :custom-error-msg="resources['R03200117']"
                      :disabled="((canEditDates || !canEditTab2 || !hasSelectionInAmendant ) && canUseTabEditRestriction && !admendmentIsEmpty) || !isDraft"
                      @onSelectedDate="onReviewTrianualChanged"
                    />
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </form>
        </div>
        <EvalDiscussion
          :is-prescholar="model.prescholarFlag != '0'"
          :can-edit="(canEditTab2 && hasSelectionInAmendant) || !canUseTabEditRestriction || admendmentIsEmpty"
        />
      </SaveObserver>
    </ValidationObserver>
  </div>
</template>

<script>
import { SectionTitle } from '@/components/pei/shared';
import EvalDiscussion from '@/components/pei/EvalDiscussion';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import CustomTextArea from '@/components/common/CustomTextArea';
import store from '@/store/index';
import mixAlert from '@/mixin/alert.mixin';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import SaveObserver from '@/components/common/SaveObserver';
import userRole from '@/utils/constants/userRoles';
import resourcesService from '@/services/resources.js';
import Error from '@/components/common/Error';
import peiSections from '@/utils/constants/pei/peiSections.js';
import peiStatus from '@/utils/constants/pei/peiStatus';

export default {
  name: 'Tab2',
  mixins: [mixAlert],
  components: {
    SectionTitle,
    EvalDiscussion,
    CustomDatePicker,
    CustomTextArea,
    ValidationObserver,
    ValidationProvider,
    SaveObserver,
    Error,
  },
  data() {
    return {
      resources: [],
      peiStatus,
      Info: {},
      model: store.getters.getPeiTab2Information,
      oldInfo: {},
      oldModel: {},
      peiId: store.getters.SelectedPei,
      showFooterBar: false,
      canEditTab2: store.getters.HasPermission('pei.editTab2'),
    };
  },
  activated() {
    store.commit('setSaveMethod', this.save);
    store.commit('setResetOriginalDataMethod', this.resetOriginalData);
    store.commit('setSaveBtnVisibility', true);
    this.setOldModels();
  },
  async mounted() {
    await this.loadResources();
    this.setOldModels();
  },
  computed: {
    isDraft() {
      return store.getters.SelectedPeiStatus == peiStatus.Borrador;
    },
    canEditDates() {
      const canEdit =
        (this.hasRoleForEditDate || this.hasPermissionForEdit) &&
        store.getters.SelectedPeiStatus == peiStatus.Borrador;

      const disableDate = !canEdit;
      return disableDate;
    },
    hasRoleForEditDate() {
      const acceptedRoles = [
        userRole.tecnico,
        userRole.admin,
        userRole.adminSaee,
        userRole.adminIl,
      ];
      const hasAcceptedRole = acceptedRoles.some(
        (role) => role === this.userRole
      );
      return hasAcceptedRole;
    },
    hasPermissionForEdit() {
      const hasCalendarPermission = store.getters.HasPermission(
        'pei.tab2.calendar'
      );
      return hasCalendarPermission;
    },
    controversyII() {
      return store.getters.getPeiControversies(peiSections.II);
    },
    ValidationTriggered() {
      return store.getters.getPeiValidationTriggered;
    },
    admendmentIsEmpty(){
      return this.$store.state["$_admendment"].sections.length == 0;
    },
    canUseTabEditRestriction(){      
      return this.$store.state["$_admendment"].correlationParameter[0].staticValue === "true";
    },
    hasSelectionInAmendant(){
      return this.$store.state["$_admendment"].sections.some(x=>x.sectionId == parseInt(peiSections.II));
    },
    canShowSectionEditable(){
      return this.hasSelectionInAmendant && !this.admendmentIsEmpty;
    },   
  },
  methods: {
    saveTab() {
      store.dispatch('saveChangesOnForm');
    },
    async loadResources() {
      let resourceCodes = [
        'R03200115',
        'R03200116',
        'R03200117',
        'R03200110',
        'R03200109',
        'R03200108',
      ];

      this.resources = await resourcesService.LoadValidationMessages(
        resourceCodes
      );
    },
    async save() {
      const data = {
        PeiId: this.model.peiId,
        EvaluationAnalysisDate: this.model.evaluationAnalysisDate,
        EvaluationTriannualDate: this.model.evaluationTriannualDate,
        GeneralImpedimentDescription: this.model.generalImpedimentDescription,
      };
      let self = this;
      self
        .$ApiPut('/api/pei/update', data)
        .then(() => {
          self.ShowToast(
            self.resources['R03200110'],
            self.resources['R03200109'],
            'success'
          );
        })
        .catch((err) => {
          self.ShowToast(err, self.resources['R03200108'], 'error');
        });
    },
    resetOriginalData() {
      this.model = { ...this.oldModel };
      this.Info = { ...this.oldInfo };
    },
    setOldModels() {
      const model = { ...this.model };
      if (Object.keys(model).length > 0) {
        this.oldModel = model;
      }

      const infoModel = { ...this.Info };
      if (Object.keys(infoModel).length > 0) {
        this.oldInfo = infoModel;
      }
    },
    onAnalysisEvaluationChanged(date) {
      if (date) {
        this.Info.evaluationAnalysisDate = new Date(date);
      }
    },
    onReviewTrianualChanged(date) {
      if (date) {
        this.Info.evaluationTriannualDate = new Date(date);
      }
    },
    async getPei() {
      let self = this;
      self
        .$ApiGet('/api/pei/getpeivaluations?peiId=' + self.peiId)
        .then((res) => {
          self.model = res.data;
          if (res.data.evaluationAnalysisDate) {
            self.model.evaluationAnalysisDate = new Date(
              res.data.evaluationAnalysisDate
            );
          }
          if (res.data.evaluationTriannualDate) {
            self.model.evaluationTriannualDate = new Date(
              res.data.evaluationTriannualDate
            );
          }
          self.setOldModels();
          self.resolve(res);
        })
        .catch((err) => {
          self.response = err;
        });
    },
  },
};
</script>
<style scoped>
.title-date {
  margin-bottom: 15px;
}
.info-comment {
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  opacity: 1;
}
.info-titule {
  margin-left: 17px;
  margin-top: -35px;
  margin-bottom: 20px;
  text-align: left;
  font: Bold 14px/17px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}
.btn-space1 {
  margin-top: -23px;
  margin-right: 5px;
}

.btn-dis {
  background-color: #354e52;
  color: #fff;
}

.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.btn-green1 {
  background-color: #2db782;
  color: #ffffff !important;
}

.btn-green1:hover {
  background-color: #20a874;
  color: #ffffff !important;
}

.calendar-fixed-size {
  max-width: 173px;
}

.comment-sub {
  font-weight: 100;
}

.footer-success {
  margin: 8px !important;
}
.mt-neg-35 {
  margin-top: -35px !important;
}

.special-margin-bottom {
  margin-bottom: 80px;
}
</style>
